/* AGC CardShop – Warenkorb-Drawer (ersetzt den Theme-Drawer) + deutsche Texte */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var R = (window.Foil && window.Foil.routes) || {};
  var CART = R.cart_url || '/cart';
  var CHANGE = (R.cart_change_url || '/cart/change') + '.js';
  var ADD = (R.cart_add_url || '/cart/add') + '.js';

  function money(cents) {
    var f = (window.Foil && window.Foil.money_format) || '{{amount_with_comma_separator}} €';
    var v = (cents / 100).toFixed(2), n = Math.round(cents / 100).toString();
    var withComma = v.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var noDec = n.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, n)
            .replace(/\{\{\s*amount\s*\}\}/, v);
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function img(url, w) { if (!url) return ''; return url.indexOf('cdn.shopify.com') > -1 ? url.replace(/(\.\w+)(\?|$)/, '_' + w + 'x$1$2') : url; }
  function getCart() { return fetch(CART + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function emit(cart) { document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart })); }

  var I = {
    close: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>',
    trash: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>',
    lock: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="18" height="11" x="3" y="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    truck: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62L18.3 9.38a1 1 0 0 0-.78-.38H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>',
    gift: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>',
    plus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/><path d="M12 5v14"/></svg>',
    minus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    arrow: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>'
  };

  class AgcCart extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.freeShipping || '10000', 10);
      this.shopUrl = this.dataset.shopUrl || '/collections/all';
      this.payments = (this.querySelector('template[data-payments]') || {}).innerHTML || '';
      this.cart = null; this.prevTotal = 0; this.wasFree = null; this.recoFor = null;
      this.innerHTML = this.shell();
      this.panel = this.querySelector('.agc-cart__panel');
      this.body = this.querySelector('.agc-cart__body');
      this.foot = this.querySelector('.agc-cart__foot');
      this.countEl = this.querySelector('.agc-cart__count');
      this.ship = this.querySelector('.agc-cart__ship');
      var self = this;
      this.addEventListener('click', function (e) { self.onClick(e); });
      document.addEventListener('cart:open', function () { self.open(); });
      document.addEventListener('cart:updated', function (e) { if (e.detail && e.detail.items) { self.cart = e.detail; if (self.isOpen) self.render(); } });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.isOpen) self.close(); });
    }
    shell() {
      return '<div class="agc-cart__backdrop" data-agc-close></div>' +
        '<aside class="agc-cart__panel" role="dialog" aria-modal="true" aria-label="Warenkorb" tabindex="-1">' +
          '<header class="agc-cart__head"><h2>Dein Warenkorb <span class="agc-cart__count">0</span></h2>' +
          '<button type="button" class="agc-cart__x" data-agc-close aria-label="Warenkorb schließen">' + I.close + '</button></header>' +
          '<div class="agc-cart__ship" hidden></div>' +
          '<div class="agc-cart__body"></div>' +
          '<footer class="agc-cart__foot" hidden></footer>' +
        '</aside>';
    }
    open() {
      if (this.isOpen) { this.render(); return; }
      this.isOpen = true; this.lastFocus = document.activeElement;
      this.hidden = false; this.classList.add('is-open');
      document.documentElement.classList.add('agc-cart-open');
      document.body.style.overflow = 'hidden';
      var self = this;
      if (!this.cart) this.body.innerHTML = this.skeleton();
      getCart().then(function (c) { self.cart = c; self.render(true); }).catch(function () { self.render(true); });
      setTimeout(function () { self.panel.focus({ preventScroll: true }); }, 60);
    }
    close() {
      if (!this.isOpen) return;
      this.isOpen = false; this.classList.remove('is-open'); this.classList.add('is-closing');
      document.documentElement.classList.remove('agc-cart-open');
      var self = this;
      setTimeout(function () { self.classList.remove('is-closing'); self.hidden = true; document.body.style.overflow = ''; if (self.lastFocus && self.lastFocus.focus) self.lastFocus.focus(); }, reduce ? 0 : 420);
    }
    skeleton() {
      var s = '';
      for (var i = 0; i < 2; i++) s += '<div class="agc-cart__sk"><span></span><div><i></i><i></i><i></i></div></div>';
      return s;
    }
    render(entering) {
      var c = this.cart || { items: [], item_count: 0, total_price: 0 };
      var items = c.items || [];
      this.countEl.textContent = c.item_count || 0;
      this.countEl.classList.remove('is-pop'); void this.countEl.offsetWidth; this.countEl.classList.add('is-pop');
      this.renderShipping(c.total_price || 0, items.length);
      if (!items.length) {
        this.body.innerHTML = this.empty();
        this.foot.hidden = true; this.foot.innerHTML = '';
        return;
      }
      var self = this;
      this.body.innerHTML = '<ul class="agc-cart__items">' + items.map(function (it, i) { return self.item(it, i, entering); }).join('') + '</ul>' +
        '<div class="agc-cart__reco" hidden><h3>Das könnte dir auch gefallen</h3><div class="agc-cart__reco-row"></div></div>';
      this.renderFoot(c);
      this.loadReco(items[0].product_id, items);
    }
    renderShipping(total, hasItems) {
      if (!this.threshold) { this.ship.hidden = true; return; }
      var left = this.threshold - total, pct = Math.min(100, Math.round(total / this.threshold * 100));
      var free = left <= 0;
      this.ship.hidden = !hasItems;
      this.ship.className = 'agc-cart__ship' + (free ? ' is-free' : '');
      this.ship.innerHTML = '<p>' + (free ? I.gift + '<span><b>Geschafft!</b> Gratis Versand (DE) + Geschenk sind dabei</span>'
        : I.truck + '<span>Noch <b>' + money(left) + '</b> bis zu <b>Gratis Versand</b> (DE) + Geschenk</span>') + '</p>' +
        '<div class="agc-cart__bar"><span style="width:' + pct + '%"></span></div>';
      if (free && this.wasFree === false && hasItems) this.confetti();
      this.wasFree = free;
    }
    item(it, i, entering) {
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="agc-cart__variant">' + esc(it.variant_title) + '</p>' : '';
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<li class="agc-cart__item' + (entering ? ' is-enter' : '') + '" style="--i:' + i + '" data-key="' + esc(it.key) + '">' +
        '<a href="' + esc(it.url) + '" class="agc-cart__img">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</a>' +
        '<div class="agc-cart__info">' +
          '<a href="' + esc(it.url) + '" class="agc-cart__title">' + esc(it.product_title) + '</a>' + variant +
          '<div class="agc-cart__row">' +
            '<div class="agc-cart__qty" role="group" aria-label="Menge">' +
              '<button type="button" data-qty="-1" aria-label="Menge verringern">' + (it.quantity <= 1 ? I.trash : I.minus) + '</button>' +
              '<span aria-live="polite">' + it.quantity + '</span>' +
              '<button type="button" data-qty="1" aria-label="Menge erhöhen">' + I.plus + '</button>' +
            '</div>' +
            '<div class="agc-cart__price">' + was + '<strong>' + money(it.final_line_price) + '</strong></div>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="agc-cart__rm" data-remove aria-label="' + esc(it.product_title) + ' entfernen">' + I.trash + '</button>' +
      '</li>';
    }
    empty() {
      return '<div class="agc-cart__empty">' +
        '<div class="agc-cart__stack" aria-hidden="true"><span></span><span></span><span></span></div>' +
        '<h3>Dein Warenkorb ist noch leer</h3><p>Zeit für neue Karten! Stöbere durch unsere Sealed Produkte.</p>' +
        '<a href="' + esc(this.shopUrl) + '" class="agc-btn agc-btn--gold">Jetzt stöbern ' + I.arrow + '</a></div>';
    }
    renderFoot(c) {
      this.foot.hidden = false;
      var disc = (c.cart_level_discount_applications || []).length && c.original_total_price > c.total_price
        ? '<div class="agc-cart__line agc-cart__line--disc"><span>Rabatt</span><span>−' + money(c.original_total_price - c.total_price) + '</span></div>' : '';
      this.foot.innerHTML = disc +
        '<div class="agc-cart__line agc-cart__total"><span>Zwischensumme</span><strong data-total>' + money(c.total_price) + '</strong></div>' +
        '<p class="agc-cart__note">Inkl. MwSt. Versandkosten werden an der Kasse berechnet.</p>' +
        '<a href="/checkout" class="agc-cart__checkout">' + I.lock + '<span>Sicher zur Kasse</span><i aria-hidden="true"></i></a>' +
        '<button type="button" class="agc-cart__continue" data-agc-close>Weiter einkaufen</button>' +
        (this.payments ? '<div class="agc-cart__pay">' + this.payments + '</div>' : '');
      this.countUp(this.foot.querySelector('[data-total]'), this.prevTotal, c.total_price);
      this.prevTotal = c.total_price;
    }
    countUp(el, from, to) {
      if (!el || reduce || from === to) return;
      var start = null, dur = 600;
      function step(t) {
        if (!start) start = t; var p = Math.min(1, (t - start) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = money(Math.round(from + (to - from) * e));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    loadReco(productId, items) {
      var box = this.querySelector('.agc-cart__reco'); if (!box) return;
      var self = this, inCart = items.map(function (i) { return i.product_id; });
      var fill = function (products) {
        var list = (products || []).filter(function (p) { return inCart.indexOf(p.id) === -1 && p.available; }).slice(0, 4);
        if (!list.length) return;
        box.hidden = false;
        box.querySelector('.agc-cart__reco-row').innerHTML = list.map(function (p, i) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          return '<div class="agc-cart__mini" style="--i:' + i + '"><a href="' + esc(p.url) + '" class="agc-cart__mini-img">' + (p.featured_image ? '<img src="' + esc(img(p.featured_image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
            '<a href="' + esc(p.url) + '" class="agc-cart__mini-title">' + esc(p.title) + '</a>' +
            '<div class="agc-cart__mini-foot"><strong>' + money(p.price) + '</strong>' +
            (v && (p.variants || []).length === 1 ? '<button type="button" data-add="' + v.id + '" aria-label="' + esc(p.title) + ' hinzufügen">' + I.plus + '</button>' : '<a href="' + esc(p.url) + '" aria-label="Ansehen">' + I.arrow + '</a>') +
            '</div></div>';
        }).join('');
      };
      if (this.recoFor === productId && this.recoCache) { fill(this.recoCache); return; }
      this.recoFor = productId;
      fetch('/recommendations/products.json?product_id=' + productId + '&limit=6')
        .then(function (r) { return r.json(); })
        .then(function (j) { self.recoCache = j.products || []; fill(self.recoCache); })
        .catch(function () {});
    }
    onClick(e) {
      var t = e.target;
      if (t.closest('[data-agc-close]')) { e.preventDefault(); this.close(); return; }
      var li = t.closest('.agc-cart__item');
      var self = this;
      if (li && t.closest('[data-qty]')) {
        var delta = parseInt(t.closest('[data-qty]').getAttribute('data-qty'), 10);
        var q = parseInt(li.querySelector('.agc-cart__qty span').textContent, 10) + delta;
        if (q <= 0) return this.remove(li);
        li.classList.add('is-busy');
        post(CHANGE, { id: li.getAttribute('data-key'), quantity: q }).then(function (c) { self.cart = c; emit(c); })
          .catch(function (err) { li.classList.remove('is-busy'); self.toast((err && err.description) || 'Leider nicht mehr auf Lager.'); });
        return;
      }
      if (li && t.closest('[data-remove]')) { this.remove(li); return; }
      var add = t.closest('[data-add]');
      if (add) {
        add.classList.add('is-busy');
        post(ADD, { items: [{ id: parseInt(add.getAttribute('data-add'), 10), quantity: 1 }] })
          .then(getCart).then(function (c) { self.cart = c; emit(c); bump(); })
          .catch(function () { add.classList.remove('is-busy'); self.toast('Konnte nicht hinzugefügt werden.'); });
      }
    }
    remove(li) {
      var self = this;
      li.classList.add('is-leaving');
      setTimeout(function () {
        post(CHANGE, { id: li.getAttribute('data-key'), quantity: 0 }).then(function (c) { self.cart = c; emit(c); });
      }, reduce ? 0 : 320);
    }
    toast(msg) {
      var t = document.createElement('div'); t.className = 'agc-cart__toast'; t.textContent = msg;
      this.panel.appendChild(t); setTimeout(function () { t.remove(); }, 2800);
    }
    confetti() {
      if (reduce) return;
      var box = document.createElement('div'); box.className = 'agc-confetti'; box.setAttribute('aria-hidden', 'true');
      var colors = ['#f59e0b', '#fde68a', '#818cf8', '#34d399', '#f472b6', '#ffffff'];
      for (var i = 0; i < 46; i++) {
        var s = document.createElement('i');
        s.style.left = (Math.random() * 100) + '%';
        s.style.background = colors[i % colors.length];
        s.style.setProperty('--dx', (Math.random() * 160 - 80).toFixed(0) + 'px');
        s.style.setProperty('--r', (Math.random() * 720 - 360).toFixed(0) + 'deg');
        s.style.animationDelay = (Math.random() * .25).toFixed(2) + 's';
        s.style.animationDuration = (1.1 + Math.random() * .9).toFixed(2) + 's';
        box.appendChild(s);
      }
      this.panel.appendChild(box); setTimeout(function () { box.remove(); }, 2400);
    }
  }
  function bump() {
    document.querySelectorAll('[data-cart-open]').forEach(function (c) { c.classList.remove('agc-bump'); void c.offsetWidth; c.classList.add('agc-bump'); });
  }
  if (!customElements.get('agc-cart-drawer')) customElements.define('agc-cart-drawer', AgcCart);

  /* Englische Texte aus dem Theme-Skript eindeutschen */
  var DICT = {
    'Adding...': 'Wird hinzugefügt …', 'Add to cart': 'In den Warenkorb', 'Sold out': 'Ausverkauft',
    'Products': 'Produkte', 'Collections': 'Kategorien', 'Pages': 'Seiten', 'View all results': 'Alle Ergebnisse anzeigen'
  };
  function fixNode(n) {
    if (n.nodeType === 3) {
      var raw = n.nodeValue, s = raw.trim();
      if (!s) return;
      if (DICT[s]) { n.nodeValue = raw.replace(s, DICT[s]); return; }
      var m = s.match(/^Only (\d+) left$/); if (m) { n.nodeValue = raw.replace(s, 'Nur noch ' + m[1] + ' auf Lager'); return; }
      m = s.match(/^No results for "(.*)"$/); if (m) { n.nodeValue = raw.replace(s, 'Keine Ergebnisse für „' + m[1] + '“'); }
      return;
    }
    if (n.nodeType !== 1) return;
    if (n.matches && n.matches('[data-search-input]')) n.setAttribute('placeholder', 'Suche nach Karten, Sets, Produkten …');
    if (n.matches && n.matches('[data-search-close]')) n.setAttribute('aria-label', 'Suche schließen');
    var w = document.createTreeWalker(n, NodeFilter.SHOW_TEXT); var x;
    while ((x = w.nextNode())) fixNode(x);
    if (n.querySelectorAll) n.querySelectorAll('[data-search-input]').forEach(function (el) { el.setAttribute('placeholder', 'Suche nach Karten, Sets, Produkten …'); });
  }
  var mo = new MutationObserver(function (list) {
    list.forEach(function (m) {
      if (m.type === 'characterData') fixNode(m.target);
      m.addedNodes && m.addedNodes.forEach(fixNode);
    });
  });
  function start() { mo.observe(document.body, { childList: true, subtree: true, characterData: true }); fixNode(document.body); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
